
// en, de, fr, pt
export default {
  en: {
    Dashboard: "Dashboard",
    eCommerce: "eCommerce",
    Apps: "Apps",
    Todo: "Todo",
    Chat: "Chat",
    Email: "Email",
    Calendar: "Calendar",
    FullCalendar: "Full Calendar",
    SimpleCalendar: "Simple Calendar",
    Shop: "Shop",
    Cart: "Cart",
    WishList: "Wish List",
    Checkout: "Checkout",
    UIElements: "UI Elements",
    DataList: "Data List",
    ListView: "List View",
    ThumbView: "Thumb View",
    Grid: "Grid",
    Vuesax: "Vuesax",
    Tailwind: "Tailwind",
    Colors: "Colors",
    Card: "Card",
    Basic: "Basic",
    Statistics: "Statistics",
    Analytics: "Analytics",
    CardActions: "Card Actions",
    CardColors: "Card Colors",
    Table: "Table",
    agGridTable: "agGrid Table",
    Components: "Components",
    Alert: "Alert",
    Avatar: "Avatar",
    Badge: "Badge",
    Breadcrumb: "Breadcrumb",
    Button: "Button",
    ButtonGroup: "Button Group",
    Chip: "Chip",
    Collapse: "Collapse",
    Dialogs: "Dialogs",
    Divider: "Divider",
    DropDown: "DropDown",
    List: "List",
    Loading: "Loading",
    Navbar: "Navbar",
    Notifications: "Notifications",
    Pagination: "Pagination",
    Popup: "Popup",
    Progress: "Progress",
    Sidebar: "Sidebar",
    Slider: "Slider",
    Tabs: "Tabs",
    Tooltip: "Tooltip",
    Upload: "Upload",
    FormsAndTable: "Forms & Table",
    FormElements: "Form Elements",
    Select: "Select",
    Switch: "Switch",
    Checkbox: "Checkbox",
    Radio: "Radio",
    Input: "Input",
    NumberInput: "Number Input",
    Textarea: "Textarea",
    FormLayouts: "Form Layouts",
    FormWizard: "Form Wizard",
    FormValidation: "Form Validation",
    FormInputGroup: "Form Input Group",
    Pages: "Pages",
    Authentication: "Authentication",
    Login: "Login",
    Register: "Register",
    ForgotPassword: "Forgot Password",
    ResetPassword: "Reset Password",
    LockScreen: "Lock Screen",
    Miscellaneous: "Miscellaneous",
    ComingSoon: "Coming Soon",
    Error: "Error",
    404: "404",
    500: "500",
    NotAuthorized: "Not Authorized",
    Maintenance: "Maintenance",
    Profile: "Profile",
    Invoice: "Invoice",
    FAQ: "FAQ",
    Search: "Search",
    KnowledgeBase: "Knowledge Base",
    ChartsAndMaps: "Charts & Maps",
    Charts: "Charts",
    ApexCharts: "Apex Charts",
    chartjs: "chartjs",
    echarts: "echarts",
    chartist: "chartist",
    GoogleMap: "Google Map",
    Extensions: "Extensions",
    QuillEditor: "Quill Editor",
    DragAndDrop: "Drag & Drop",
    Datepicker: "Datepicker",
    DatetimePicker: "Datetime Picker",
    AccessControl: "Access Control",
    EditorView: "Editor View",
    AdminView: "Admin View",
    I18n: "I18n",
    Carousel: "Carousel",
    Clipboard: "Clipboard",
    ContextMenu: "Context Menu",
    StarRatings: "Star Ratings",
    Autocomplete: "Autocomplete",
    Tree: "Tree",
    Others: "Others",
    MenuLevels: "Menu Levels",
    MenuLevel2p1: "Menu Level 2.1",
    MenuLevel2p2: "Menu Level 2.2",
    MenuLevel3p1: "Menu Level 3.1",
    MenuLevel3p2: "Menu Level 3.2",
    DisabledMenu: "Disabled Menu",
    Support: "Support",
    Documentation: "Documentation",
    RaiseSupport: "Raise Support",
    demoTitle: "Card Title",
    demoText:
      "Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.",
    SalesPartners: "SalesPartners",
  },
  fa: {
    Id:"شناسه",
    Dashboard: "داشبورد",
    UserManagement: "مدیریت کاربران",
    Users: "کاربران",
    Roles: "نقش‌ها",
    Profile: "پروفایل",
    Login: "ورود",
    Register: "ثبت‌نام",
    Email: "پست الکترونیک",
    Password: "کلمه عبور",
    Inbox: "صندوق پیام",
    Logout: "خروج",
    Search: "جست‌وجو",
    Avajang: "آواژنگ",
    AllrightsReservedForAvajang:
      "کلیه حقوق این سایت  برای آواژنگ محفوظ می‌باشد.",
    WarehouseManagement: "مدیریت انبار",
    Warehouses: "انبارها",
    Inventories: "قفسه‌ها",
    Action: "عملیات",
    Admin: "ادمین",
    AdminName: "نام ادمین",
    SelectAdmin: "انتخاب ادمین",
    CheckInTransactions: "رسیدهای ورود",
    CheckInTransaction: "رسید ورود",
    CheckOutTransactions: "حواله‌های خروج",
    CheckedOutTransaction: "حواله‌های خروج صادر شد",
    DischargePermissionRejected: "مجوز خروج رد شده",
    DischargePermissionCreated: "مجوز خروج صادر شده",
    CheckOutTransaction: "حواله خروج",
    TransferDocument: "سند انتقال",
    CreateNewWarehouse: "درج انبار جدید",
    WarehouseName: "نام انبار",
    Warehouse: "انبار",
    WarehouseCode: "کد انبار",
    WarehouseType: "نوع انبار",
    WarehouseAddress: "آدرس انبار",
    AutomationCode: "کد اتوماسیون",
    StoreName: "نام انبار",
    WarehouseHandling: "انبارگردانی",
    WarehouseHandlingDetails: "انبارگردانی جزییات",
    ChooseFIleForWarehouseHandlingInExcel:
      "انتخاب فایل برای انبارگردانی به صورت اکسل",
    CreateNewWarehouseHandling: "ثبت انبارگردانی جدید",
    WarehousingCourse: "دوره انبارگردانی",
    LogicalBalance: "موجودی منطقی",
    PhysicalBalance: "موجودی فیزیکی",
    Name: "نام",
    Active: "فعال",
    Save: "ثبت و ذخیره",
    Status: "وضعیت",
    CreateNewShelve: "درج قفسه جدید",
    EditShelve: "ویرایش قفسه",
    ShelveName: "نام قفسه",
    Shelve: "قفسه",
    ShelveType: "نوع قفسه",
    Cardex: "کاردکس",
    CreationDate: "تاریخ ثبت",
    Creator: "ثبت کننده ",
    Description: "توضیحات",
    DescriptionAndDateSettlement: "توضیحات و تاریخ تسویه",
    Applicant: "درخواست کننده",
    Product: "محصول ",
    ProductName: "نام محصول ",
    ProductId: "شناسه محصول",
    ProductCode: "کد محصول ",
    Count: "تعداد",
    CreateCheckInTransactions: "ثبت رسید ورود جدید",
    CreateCheckInForReturnCheckOut: "ثبت رسید برای حواله خروج برگشتی",
    CreateCheckOutTransactions: "ثبت حواله خروج جدید",
    OriginWarehouse: "انبار مبدا",
    DestinationWarehouse: "انبار مقصد",
    OriginInventory: "قفسه مبدا",
    DestinationInventory: "قفسه مقصد",
    ItemCode: "کد کالا",
    CountOfQuota: "تعداد سهمیه",
    Products: "محصولات",
    ProductManagement: "مدیریت محصولات",
    Items: "آیتم‌ها",
    CreateNewProduct: "درج محصول جدید",
    BasicInfo: "اطلاعات پایه",
    TechnicalSpecifications: "مشخصات فنی",
    Gallery: "گالری تصاویر",
    Events: "رویدادها",
    PersianName: "نام فارسی",
    EnglishName: "نام انگلیسی",
    Category: "دسته‌بندی",
    MetaDescription: "شرح متا",
    KeyWords: "کلمات کلیدی",
    Pros: "نکات مثبت",
    Cons: "نکات منفی",
    CoverImage: "تصویر کاور",
    LogoImage: "تصویر لوگو",
    Submit: "ثبت",
    BackToList: "بازگشت به لیست",
    Brand: "برند",
    Caption: "توضیح",
    Remove: "حذف",
    Edit: "ویرایش",
    GenericProduct: "دسته‌",
    GenericProducts: "دسته‌ها",
    CreateNewGenericProduct: "درج دسته جدید",
    EditProductAttribute: "ویرایش صفت محصول",
    Attributes: "مشخصات",
    GroupName: "نام گروه",
    Adjectives: "صفت‌ها",
    AttributesCount: "تعداد صفت‌ها",
    CreateNewGroup: "درج گروه جدید",
    CreateNewAttribute: "درج صفت جدید",
    Title: "عنوان",
    Type: "نوع",
    Colors: "رنگ‌ها",
    Color: "رنگ‌",
    Brands: "برندها",
    Warranties: "گارانتی‌ها",
    Warranty: "گارانتی",
    WarrantyCode: "کد گارانتی",
    In: "در",
    CreateNewCompany: "درج شرکت جدید",
    EditCompany: "ویرایش شرکت",
    EditWarranty: "ویرایش گارانتی",
    AttributeManagement: "مدیریت صفت‌ها",
    WarrantyName: "نام گارانتی",
    CreateNewWarranty: "درج گارانتی جدید",
    CreateNewColor: "درج رنگ جدید",
    ColorCode: "کد‌رنگ",
    CreateNewBrand: "درج برند جدید",
    Categories: "دپارتمان‌ها",
    CreateNewCategory: "درج دپارتمان جدید",
    CategoryName: "نام دپارتمان",
    EditCategory: "ویرایش دپارتمان",
    CreateOn: "تاریخ درج",
    EditBrand: "ویرایش برند",
    BrandName: "نام برند",
    Of: "از",
    ExportAsCSV: "دریافت فایل اکسل",
    EditColor: "ویرایش رنگ",
    AttributeName: "عنوان صفت",
    CreateAndManageGroupsAndAttributes: "درج و مدیریت گروه‌ها و صفت‌ها",
    SystemAttributes: "صفت‌های سیستم",
    PleaseEnterGroupName: "لطفا نام گروه را وارد نمایید.",
    SearchAttributes: "جست‌وجوی صفت‌ها",
    EditWarehouse: "ویرایش انبار",
    Location: "موقعیت",
    longitude: "طول جغرافیایی",
    latitude: "عرض جغرافیایی",
    Add: "افزودن",
    AddToList: "افزودن به لیست",
    SerialNumbers: "سریال‌ها",
    Shelves: "قفسه‌ها",
    NoRecordsFound: "رکوردی یافت نشد!",
    SaveAndContinue: "ثبت و ادامه",
    Continue: "ادامه",
    Sale: "فروش",
    SaleContracts: "قراردادهای فروش",
    ContractType: "نوع قرارداد",
    StartDate: "تاریخ شروع",
    EndDate: "تاریخ پایان",
    CreateNewContract: "ایجاد قرارداد جدید",
    ContractName: "عنوان قرارداد",
    ContractId: "شناسه قرارداد",
    EditContract: "ویرایش قرارداد",
    SaleManagemnet: "مدیریت فروش",
    SaleContractManagemnet: "مدیریت قرارداد فروش",
    CreateNewItem: "درج آیتم جدید",
    ModelNumber: "مدل نامبر",
    SerialNumber: "شماره سریال",
    CreateSerial: "درج سریال",
    Reset: "شروع مجدد",
    CustomerManagement: "مدیریت مشتریان",
    Customers: "مشتریان",
    Department: "دپارتمان",
    DepartmentName: "نام دسته",
    ProductColorName: "نام رنگ",
    EditItem: "ویرایش آیتم",
    EditProduct: "ویرایش محصول",
    CreateIndividualCustomer: "درج مشتری حقیقی",
    CreateLegalCustomer: "درج مشتری حقوقی",
    CreateCustomer: "درج مشتری",
    EditCustomer: "ویرایش مشتری",
    Individual: "حقیقی",
    Legal: "حقوقی",
    Firstname: "نام",
    Lastname: "نام خانوادگی",
    SocialSecurityNumber: "کد ملی",

    BirthCertificateNumber: "شماره شناسنامه",

    PhoneArea: "پیش شماره",
    Address: "آدرس",
    PostalCode: "کدپستی",
    CompanyRegistrationNumber: "شماره ثبت",
    CompanyNationalId: "شناسه ملی",
    CompanyName: "نام شرکت",

    EconomicCode: "کد اقتصادی",
    Management: "مدیریت",
    Setting: "تنظیمات",
    EditAttributes: "ویرایش صفات",
    InternalOrders: "سفارشات داخلی",
    WebSiteBaskets: "سفارشات وبسایت",
    ChannelBaskets: "سفارشات نمایندگان",
    DirectSaleBaskets: "سفارشات مستقیم",
    CorporateBaskets: "سفارشات سازمانی",
    InsertNewBaskets: "ثبت سفارش جدید",
    EditAttribute: "ویرایش صفت",
    Customer: "مشتری",
    CustomerName: "نام مشتری",
    CustomerType: "نوع مشتری",
    Contract: "قرارداد",
    Price: "قیمت",
    PriceRial: "قیمت (ریال)",
    ContentManagement: "مدیریت محتوا",
    Blog: "وبلاگ",
    FAQ: "سوالات متداول",
    Pages: "صفحات",
    Banners: "بنرهای تبلیغاتی",
    EditBanner: "ویرایش بنر تبلیغاتی",
    FromDate: "از تاریخ",
    Amounts: "مقدار",
    ToDate: "تا تاریخ",
    CreationDates: "تاریخ ایجاد",
    TypeFinancialTransaction: "نوع تراکنش مالی",
    SubmitFilter: "اعمال فیلتر",
    ReferenceID: "شناسه مرجع",
    Removal: "برداشت",
    Deposit: "واریز",
    CheckInCount: "وارده",
    CheckOutCount: "صادره",
    ResetFilter: "حذف فیلتر",
    StockBalance: "موجودی کالا",
    BalanceStatus: "وضعیت موجودی",
    Balance: "مانده",
    AllWarehouses: "کل انبارها",
    DividedByWarehouseAndShelve: "به تفکیک انبار و قفسه",
    CreateNewPage: "درج صفحه جدید",
    EditPage: "ویرایش صفحه",
    SubTitle: "عنوان دوم",
    Priority: "اولویت",
    Summary: "خلاصه",
    Sum: "مجموع",
    BannerPosition: "محل قرارگیری بنر",

    CreateNewBanner: "درج بنر جدید",
    CreateBanner: "درج بنر تبلیغاتی",
    Link: "لینک",
    Image: "تصویر",
    MobileImage: "تصویر موبایل",
    CreateNewPost: "درج پست جدید",
    CreatePost: "درج پست",
    Tags: "تگ‌ها",
    PostCategories: "دسته‌بندی‌ پست‌ها",
    CreateNewTag: "درج تگ جدید",

    EditTag: "ویرایش تگ",
    CreateNewPostCategory: "درج دسته‌بندی جدید",
    EditPostCategory: "ویرایش دسته‌بندی ",
    EditPost: "ویرایش پست",
    ParentCategory: "دسته‌بندی والد",
    IsLeaf: "سطح آخر",
    ShowInSystem: "نمایش در سیستم",
    ShortDescription: "توضیح کوتاه",
    ShowInHeader: "نمایش در هدر",
    PinToTop: "فیکس کردن در بالای صفحه",
    HideSideBar: "نمایش به صورت تمام صفحه",
    ShowInHome: "نمایش در صفحه نخست",
    Show: "نمایش",
    Conclusion: "نتیجه‌گیری",
    SourceTitle: "عنوان منبع",
    SourceLink: "لینک منبع",
    URLSlug: "عنوان لینک",
    PostRate: "امتیاز پست",
    PublishDate: "تاریخ انتشار",
    WaitingQueue: "صف انتظار",
    InProcess: "در حال پردازش",
    ReadyToSend: "صف ارسال",
    Sent: "ارسال شده",
    Sending: "درحال ارسال",
    IgnoredOrders: "مردودی‌",
    IgnoredOrdersPischargePermission: "مردودی مجوز خروج",
    ReturnedOrders: "مرجوعی‌ها",
    UnSuccessOrders: "ناموفق",
    PendingPaymentQueue: "در انتظار پرداخت",
    PaidPaymentQueue: "پرداخت‌شده‌ها",
    FinalQueueOrders: "سفارشات قطعی ",
    CheckInDetails: "جزئیات رسید ورود",
    CheckOutDetails: "جزئیات حواله خروج",
    ViewDetails: "مشاهده جزئیات",
    ViewAnswers: "مشاهده پاسخ",
    Serial: "سریال",
    AllItems: "کل آیتم‌ها",
    WaitingForStatusDetermination: "در انتظار تعیین وضعیت",
    StatusDetermination: "تعیین وضعیت",
    Measurable: "مقداری",
    Serialize: "سریالی",
    Pricing: "قیمت گذاری",
    BasePrice: "قیمت پایه",
    AllowedReduction: "کاهش مجاز",
    AllowedIncrease: "افزایش مجاز",
    StockCirculation: "گردش کالا",
    SerialCirculation: "گردش سریالی",
    SerialBalance: "موجودی سریالی",
    InventoryTransactionOperation: "دفتر عملیات انبار",
    BalanceForTheBeginningOfHistory: "ابتدای دوره",
    ViewSerials: "مشاهده سریال‌ها",
    InventoryTransactionId: "شماره تراکنش",
    SearchInventoryTransactionId: "جستجو شماره تراکنش",
    ContractState: "وضعیت قرارداد",
    Reports: "گزارش‌ها",
    ToleranceType: "نوع تغییرات ",
    EditPrice: "ویرایش قیمت",
    Operation: "عملیات",
    CheckInCheckOutNumber: "شماره رسید/حواله",
    SaleItems: "آیتم‌ها",
    ColorName: "نام رنگ",
    ProductImage: "تصویر محصول",
    AssignProductToContract: "افزودن محصول به قرارداد",
    Loading: "درحال بارگذاری...",
    DeductionAndIncrease: "کسورات و اضافات",
    DeductionAndIncreaseByGenericProduct: "کسورات و اضافات بر اساس دسته",
    DeductionAndIncreaseByProduct: "کسورات و اضافات بر اساس محصول ",
    CreateDeductionAndIncreaseByGenericProduct:
      "درج کسورات و اضافات بر اساس دسته ",
    CreateDeductionAndIncreaseByProduct: "درج کسورات و اضافات بر اساس محصول ",
    EditDeductionAndIncrease: "ویرایش کسورات و اضافات ",
    CreateDeductionAndIncrease: "درج کسورات و اضافات ",
    Amount: "مقدار",
    UpdatePrice: "به‌روز‌رسانی قیمت",
    UpdateList: "لیست به‌روز‌رسانی",
    AddOrder: "ثبت سفارش",
    SearchCustomer: "جست‌وجو مشتری",
    SearchProduct: "جست‌وجو محصول",
    AssignWarehouseToContract: "افزودن انبار به قرارداد",
    Options: "گزینه‌ها",
    PriceOverhead: "سربار قیمت",
    TotalAmountForPayment: "مبلغ کل قابل پرداخت",
    InternalSales: "فروش داخلی",
    WebsiteSales: "فروش وبسایت",

    CorporateSales: "فروش سازمانی",
    DirectSales: "فروش مستقیم",
    ContarctType: "نوع قرارداد",
    CreateTransferTransactions: "ثبت سند انتقال جدید ",
    TransferTransactions: "سندهای انتقال",
    AvailableSerials: "سریال‌های موجود",
    TransferTransaction: "انتقال",
    RequesterName: "نام درخواست‌ کننده",
    RequesterUsername: "نام کاربری درخواست‌ کننده",
    OperatorName: "نام اپراتور",
    TransferTransactionsDetails: "جزئیات سند انتقال",
    TransactionType: "نوع تراکنش",
    Discounts: "تخفیفات",
    Festivals: "جشنواره‌ها",
    CreateNewFestival: "درج جشنواره جدید",
    FestivalName: "عنوان جشنواره",
    DiscountsCount: "تعداد تخفیف‌ها",
    AddNewDiscount: "درج تخفیف جدید",
    EditFestival: "ویرایش جشنواره",
    DiscountType: "نوع تخفیف",
    UnitDiscount: "تخفیف واحد",
    CalculationType: "نوع محاسبه",
    DiscountAmount: "مقدار تخفیف",
    DiscountSubmit: "ثبت تخفیف",
    CommissionSubmit: "ثبت کمیسیون",
    quantitative: "مقداری",
    Percent: "درصدی",
    EditDiscount: "ویرایش تخفیف",
    InventoryTransactionOperationType: "نوع دفتر عملیات",
    Basic: "پایه",
    Festival: "جشنواره",
    Daily: "روزانه",
    Hourly: "ساعتی",
    Archive: "آرشیو",
    ActiveDiscounts: "تخفیفات فعال",
    SubmitAndGetFileForFixedPrice: "ثبت و دریافت فایل قیمت ثابت",
    ArchiveDiscounts: "آرشیو تخفیفات",
    Filter: "فیلتر",
    ViewProducts: "مشاهده محصولات",
    ContractProducts: "محصولات قرارداد",
    CustomersSetting: "تنظیمات",
    Documents: "مدارک",
    DocumentsType: "انواع مدارک",
    CreateDocument: "ثبت مدرک",
    SaleSystem: "سیستم فروش",
    IsRequired: "اجباری",
    EditDocument: "ویرایش مدرک",
    InternalSale: "فروش داخلی",
    EndUserSale: "مصرف‌کننده نهایی",
    AgentSale: "فروش نمایندگان",
    CorporateSale: "فروش سازمانی",
    ComingSoon: "به‌زودی",
    Available: "موجود",
    NotAvailable: "ناموجود",
    MinOrderQuantity: "حداقل تعداد سفارش",
    MaxOrderQuantity: "حداکثر تعداد سفارش",
    ProductStatus: "وضعیت محصول",
    ReadyForSale: "آماده فروش",
    StopSale: "توقف فروش",
    ProductCommnets: "نظرات محصولات",
    Header: "عنوان",
    Pending: "در حال بررسی",
    Confirmed: "تایید شده",
    Rejected: "رد شده",
    ViewComment: "مشاهده نظر",
    Survey: "نظرسنجی",
    SurveyContent: "متن نظرسنجی",
    Reject: "رد",
    Confirm: "تایید",
    Forums: "پرسش‌ و پاسخ",
    Complaints:"شکایات",
    Answer: "پاسخ",
    LikedCount: "تعداد آرا مثبت",
    DisLikedCount: "تعداد آرا منفی",
    Menus: "منوها",
    CreateNewMenu: "درج منو جدید",
    DisplayOrder: "اولویت نمایش",
    MenuPosition: "جایگاه در منو",
    Published: "انتشار",
    EditMenu: "ویرایش منو",
    ShowOnHomePage: "نمایش در صفحه‌نخست",
    IncludeInTopMenu: "درج در منو بالایی",
    Vouchers: "کارت‌های هدیه",
    DiscountCodes: "کدهای تخفیف",
    DiscountCode: "کد تخفیف",
    AddVoucher: "درج کارت هدیه",
    Prefix: "پیشوند",
    MinimumBasketAmount: "حداقل مقدار سبدخرید",
    MaximumBasketAmount: "حداکثر مقدار سبدخرید",
    MinimumNumberOfItemsInBasket: "حداقل تعداد آیتم‌‌‌‌‌‌‌‌‌‌های سبدخربد",
    MaximumNumberOfItemsInBasket: "حداکثر تعداد آیتم‌‌‌‌‌‌‌‌‌‌های سبدخربد",
    CalculatedForAnAmazingDiscount: "محاسبه در تخفیفات شگفت‌انگیز",
    CreateVoucher: "درج کارت هدیه",
    AddPublicDiscountCode: "درج کدتخفیف",
    CreateDiscountCode: "درج کدتخفیف",
    TotalLimit: "حداکثر استفاده",
    LimitPerUser: "حداکثر استفاده هر کاربر",
    PriceRows: "ردیف‌های قیمت",
    ContractBasePrice: "قیمت پایه قرارداد",
    ContractPrice: "قیمت قرارداد",
    PriceWithoutBoundary: "قیمت بدون سقف و کف",
    Unchanged: "بدون تغییر",
    Floor: "کف",
    PriceFloor: "کف قیمت",
    Ceiling: "سقف",
    PriceCeiling: "سقف قیمت",
    SumOfDiscountsAmount: "جمع کل تخفیفات فعال",
    DeductionAndIncreaseAmount: "جمع کل کسورات و اضافات قرارداد",
    ValueAddedTax: "مالیات برارزش افزوده کالا",
    DefaultWarehouse: "انبار پیش فرض",
    ConsumerPrice: "قیمت مصرف‌کننده",
    Cancel: "انصراف",
    UploadImage: "بارگذاری تصویر",
    ImagePreview: "پیش نمایش تصویر",
    UploadMobileImage: "بارگذاری تصویر موبایل",
    CreateNewFAQ: "درج سوالات متداول جدید",
    FAQCategories: "دسته‌بندی‌های سوالات متداول",
    FAQCategory: "دسته‌بندی سوالات متداول",
    CreateNewFAQCategory: "درج دسته‌بندی سوالات متداول",
    UploadIcon: "بارگذاری آیکن",
    EditFAQCategory: "ویرایش دسته‌بندی سوالات متداول",
    CreateFAQ: "درج سوالات متداول",
    Question: "سوال",
    AbstractReply: "پاسخ کوتاه",
    FullReply: "پاسخ کامل",
    EditFAQ: "ویرایش سوالات رایج",
    IndividualCustomers: "مشتریان حقیقی",
    LegalCustomers: "مشتریان حقوقی",
    Parties: "طرف‌های تجاری",
    UnderCostruction: "در دست توسعه",
    PartyType: "شخصیت طرف تجاری",
    CustomerAgentType: "نوع طرف تجاری",
    OperationalError: "خطای عملیاتی",
    WrongBarcode: "سریال اشتباه",
    ExteraBarcode: "سریال اضافی",
    DuplicteBarcode: "سریال تکراری",
    DeleteWrongBarcode:"حذف سریال اشتباه",
    TryLater: "لطفا بعداً امتحان کنید ",
    OperationType: "نوع عملیات",
    Select: "انتخاب",
    InvalidPrice: "مقدار وارد شده معتبر نمی‌باشد.",
    FinancialManagement: "مدیریت مالی",
    BankPortalPayments: "پرداخت‌های درگاه بانک",
    SuccessfulPayments: "پرداخت‌های موفق",
    UnsuccessfulPayments: "پرداخت ‌های ناموفق",
    DraftOrderId: "شماره پیش فاکتور",
    PaymentAmount: "مبلغ پرداختی",
    BankStatus: "وضعیت بانک",
    Bank: "بانک",
    ReferenceId: "شناسه مرجع ",

    DraftOrders: "پیش فاکتورها",
    Orders: "فاکتورها",
    Order: "فاکتور",
    PartyName: "نام طرف تجاری",
    TaxInfo: "مشخصات مالیاتی",
    SalesAssistantName: "نام همیارفروش",
    SalesAssistant: "همیار فروش",
    Supplier: "تولید کننده",
    AccountBalance: "مانده حساب",
    Rials: "ریال",
    RialsParenthesis: " (ریال)",
    DraftOrder: "پیش فاکتور",
    OrdersList: "لیست سفارشات",
    PartyInfo: "اطلاعات خریدار",
    UnitPrice: "فی",
    TotalAmount: "مبلغ کل	",
    TotalAmountAfterDeductionOfDiscounts: "مبلغ کل پس از تخفیف	",
    SumOfDiscount: "مبلغ تخفیف	",
    TotalTaxAmount: "مالیات و عوارض",
    TotalAmountWithTax: "مبلغ کل + مالیات و عوارض",
    PhoneNumber: "شماره تلفن",
    From: "از",
    DischargePermissions: "مجوزهای خروج",
    DischargePermission: "مجوز خروج",
    ShelveBalance: "موجودی قفسه",
    ApplicantInformation: "اطلاعات درخواست دهنده",
    Itemlist: "لیست اقلام",
    DischargeCheckOut: "صدور حواله خروج",
    Back: "بازگشت",
    ConfirmDraftOrderAndCreateDischargePermission:
      "تایید پیش فاکتور و صدور مجوز خروج",
    CreateCheckout: "ثبت حواله خروج",
    OrderDetails: "جزئیات سفارش",
    RecipientName: "نام تحویل گیرنده",
    ProductColor: "رنگ محصول",
    ProductWarranty: "گارانتی محصول",
    ProductCollection: "مجموعه محصولات",
    CreateNewCollection: "درج مجموعه جدید",
    CollectionName: "عنوان مجموعه",
    Position: "موقعیت",
    ProductCollectionManagement: "مدیریت مجموعه محصولات",
    AssignProductToCollection: "افزودن محصول به مجموعه",
    ReturnOrders: "برگشت از فروش",
    ReturnReceipt: "برگشت از فروش",
    ReturnOrdersDetails: "جزئیات برگشت از فروش",
    CreateReturnOrders: "ثبت فاکتور برگشت از فروش",
    OrderId: "شماره فاکتور",
    SearchParty: "جست‌وجوی طرف تجاری",
    SelectOrder: "انتخاب فاکتور",
    CreateNewRole: "درج نقش جدید",
    RoleName: "عنوان نقش",
    SelectSerials: "انتخاب سریال",
    UserName: "نام کاربر",
    CreateNewUser: "درج کاربر جدید",
    SubmitNewUser: "ثبت کاربر جدید",
    EditUser: "ویرایش کاربر",
    UserId: "شناسه کاربر",
    EditRole: "ویرایش نقش",
    OrderCount: "تعداد فاکتور",
    ReturnOrderCount: "تعداد برگشت",
    BannerPositionInDesktopVersion: "محل قرارگیری بنر در نسخه دسکتاپ",
    BannerPositionInMobileVersion: "محل قرارگیری بنر در نسخه موبایل",
    Version: "نسخه",
    Desktop: "دسکتاپ",
    Mobile: "موبایل",
    HomeSlider: "اسلایدر اصلی، صفحه نخست",
    HomeBottomOfSlider: "زیر اسلایدر صفحه نخست",
    HomeSide: "اسلایدر کناری  صفحه نخست",
    Id:"شناسه",
    HomeHorizontalMiddleSlider: "اسلایدر میانی صفحه نخست",
    HalfOfHomePage: "1/2صفحه نخست",
    HalfOfHomeTop: "1/2 بالای، صفحه نخست",
    HalfOfHomeBottom: "1/2 پایین، صفحه نخست",
    FullHomeTop: "تک بنر،بالای صفحه نخست",
    FullHomeBottom: "تک بنر،پایین صفحه نخست",
    TypeAndTermsOfWarranty: "نوع و شرایط گارانتی",
    TermsOfWarrantyProducts: "شرایط گارانتی محصولات",
    CreateNewTypeAndTermsOfWarranty: " درج نوع و شرایط گارانتی جدید",
    ReviewQueue: "در دست بررسی",
    Processing: "در حال پردازش",
    Delivered: "تحویل داده شده",
    PartialSend: "بخشی از محموله ارسال شد",
    AllOrders: "همه سفارشات",
    BasketFlowState: "وضعیت سبدخرید",
    CreditManagement: "مدیریت اعتبارات",
    Permissions: "دسترسی‌ها",
    SearchPermissionsInRols: "جستجو دسترسی‌ در نقش‌ها",
    CreateNewPermission: "درج دسترسی جدید",
    EditPermission: "ویرایش دسترسی",
    RolePermissions: " دسترسی‌های نقش ",
    UserRoles: "نقش‌های کاربر",
    Invoice: "صورتحساب",
    Row: "ردیف",
    Print: "پرینت",
    Label: "لیبل",
    FinancialReports: "گزارش‌های مالی",
    CreateNewGroupAccount:"ایجاد گروه حساب",
    AccountId:"شناسه حساب",
    AccountTitle:"عنوان حساب",
    AccountGroupTitle:"عنوان گروه حساب",
    StartClock:"تاریخ شروع",
    ExpireClock:"تاریخ انقضا",
    RemainingAmount:"مقدار باقی مانده",
    CreateNewGeneralAccount:" ایجاد حساب کل",
    AccountGeneralTitle:"عنوان حساب کل",
    CreateNewSubsidiaryAccount:" ایجاد حساب معین",
    AccountSubsidiaryTitle:"عنوان حساب معین",
    CreateNewDetailAccount:" ایجاد حساب تفضیلی",
    AccountReferenceType:" مرجع",
    AccountReferenceId:" شناسه مرجع",
    AccountDetailTitle :" عنوان حساب تفضیلی",
    AccountFloatingTitle:"عنوان حساب شناوری",
    CreateNewFloatingAccount:" ایجاد حساب شناور",
    EditFloatingAccount:" ویرایش حساب شناوری",
    TadbirOrders: "سفارشات تدبیر",
    TadbirCustomers: "مشتریان تدبیر",
    ID: "شناسه",
    OrderType: "نوع سند",
    CustomerID: "شناسه مشتری",
    TrackingId: "شناسه رهگیری",
    WithoutTrackingId: "بدون شناسه رهگیری",
    PassagePermit: "پته عبور",
    CottageNumber: "شماره کوتاژ",
    ShipmentNumber: "شماره شیپمنت",
    TadbirCreateOn: "تاریخ ثبت تدبیر",
    OrderTimeOnSite: "تاریخ سند اصلی",
    Buy: "خرید",
    BuyReturn: "برگشت از خرید",
    SaleReturn: "برگشت از فروش",
    TadbirOrder: "جزئیات سفارش",
    IsTransferred: "انتقال یافته",
    IsDelivered: "ارسال شده",
    SpDescription: "",
    No: "خیر",
    Yes: "بله",
    SaleInfo: "اطلاعات فروش",
    TadbirCode: "کد تدبیر",
    ecCode: "شماره ملی/کد اقتصادی",
    Province: "استان",
    City: "شهر",
    BaseConsumerPrice: "قیمت پایه برای مصرف کننده",
    MinPrice: "حداقل قیمت",
    MaxPrice: "حداکثر قیمت",
    COD: "پرداخت در محل",
    OnlinePayment: "آنلاین",
    RecipientInfo: "اطلاعات تحویل گیرنده",
    FullName: "نام و نام خانوادگی",
    InvoiceRequired: "درخواست صورتحساب",
    OrderInfo: "خلاصه وضعیت سفارش",
    PaymentInfo: "جزئیات پرداخت",
    OrderNumber: "شماره سفارش",
    ShippingFee: "هزینه ارسال",
    ToPay: "قابل پرداخت",
    PaymentGateway: "درگاه پرداخت",
    ReceiptNumber: "شماره رسید	",
    Date: "تاریخ",
    Fee: "مبلغ",
    PaymentStatus: "وضعیت پرداخت",
    DownloadFile: "دانلود فایل",
    UploadFile: "آپلود فایل",
    ChooseFile: "انتخاب فایل",
    ShowPackageInfo: "نمایش اطلاعات محموله",
    Draft: "پیش نویس",
    Review: "بازبینی",
    Publish: "انتشار",
    Mellat: "ملت",
    Parsian: "پارسیان",
    ConfirmOrder: "تایید سفارش",
    RejectOrder: "رد سفارش",
    ViewRecipientInvoice: "مشاهده فاکتور خریدار",
    CheckInForReturnOrder: "ورود (برگشت از فروش)",
    CheckOutForDischargePermission: "خروج (مجوز خروج)",
    OrderTime: "تاریخ سفارش",
    SiteOrderNumber: "شماره سفارش",
    TadbirReceipts: "پرداخت‌های ثبت شده",
    ReferenceNo: "شماره مرجع",
    PaymentType: "شیوه پرداخت",
    PosId: "شناسه کارتخوان",
    ReportsOrder: "گزارشات فاکتور",
    ReportsDraftOrder: "گزارشات پیش‌فاکتور",
    TotalOrders: "کل سفارشات",
    FinalDraftOrders: "پیش فاکتورهای قطعی",
    FinalOrders: "فاکتورهای قطعی",
    TotalOrdersAmount: "جمع کل فاکتورها",
    MonthlyIncomeChart: "نمودار فروش ماهانه",
    SaleFactors: "فاکتورهای فروش",
    SaleDraftOrders: "پیش‌فاکتورهای فروش",
    SaleItemsInfo: "ریز اقلام فروش",
    BestSellers: "پر فروش ترین ها",
    TimeReports: "گزارش در بازه زمانی",
    TotalReviewQueueBaskets: "سفارشات در صف بررسی",
    TotalProcessingBaskets: "کل سفارشات در حال پردازش",
    TotalTodayBaskets: "تعداد سفارشات امروز",
    TotalYesterdayBaskets: "تعداد سفارشات دیروز",
    TotalAmountOfTodayBaskets: "جمع فروش امروز",
    TotalAmountOfYesterdayBaskets: "جمع فروش دیروز",
    Ascending: "صعودی",
    Descending: "نزولی",
    SortingBy: "مرتب سازی براساس",
    BasketManagement: "مدیریت سفارشات",
    BasketDetails: "جزئیات سفارش",
    InsertNewBasket: "درج سفارش جدید",
    AddBasket: "درج سفارش",
    InventoryReservations: "گزارش‌ رزرواسیون",
    ReservationStore: "انبار رزرو",
    ReservationRequester: "درخواست دهنده رزرو",
    StockNameShelveNameCount: "نام محصول،   نام قفسه،   تعداد",
    StockName: "نام محصول",
    Recharge: "شارژ مجدد",
    Reserves: "رزروی ها",
    Recharges: "شارژهای مجدد",
    DownloadExcelFile: "دانلود فایل اکسل",

    B2C: "مصرف کننده نهایی",
    BankType: "نوع بانک",
    BankPaymentState: "وضعیت پرداخت بانک",
    SaleInterface: "نوع فروش",
    ViewAuditTrail: "مشاهده جزئیات رویداد",

    DischargePermissionId: "شماره مجوز خروج",
    EventName: "نام رویداد",
    Members: "اعضا",
    Owner: "مالک",
    OwnerID: "شناسه مالک",
    hasBranch: "دارای شعب",
    Branch: "شعبه",
    Branches: "شعب",
    BranchLists: "لیست شعبه‌ها",
    AddBranch: "افزودن شعب",
    CreateNewAgent: "درج نماینده جدید",
    AddAgent: "افزودن نماینده",
    CreateIndividualAgent: "درج نماینده حقیقی",
    CreateLegalAgent: "درج نماینده حقوقی",
    ShopName: "نام فروشگاه",
    AgentType: "نوع نماینده",
    MemberType: "نوع عضو",
    ManagementDashboard: "داشبورد مدیریتی",
    Financial: "مالی",
    LatestConfirmedDraftOrders: " آخرین پیش فاکتورهای تایید شده",
    Party: "طرف تجاری",
    LatestBaskets: "آخرین سفارشات",
    AgentOwnerNumber: "شماره موبایل مالک",
    HoldersOfTheRightToSignName: "صاحبان حق امضا",
    EditAgents: "ویرایش نمایندگان",
    EditLegalAgent: "ویرایش نماینده حقوقی",
    EditIndividualAgent: "ویرایش نماینده حقیقی",
    ConfirmLegalAgent: "تایید نماینده حقوقی",
    ConfirmIndividualAgent: "تایید نماینده حقیقی",
    LeastSaleProducts: "کم فروش ترین کالاها ",
    TodayCustomersBaskets: "تعداد سفارشات امروز مصرف کنندگان",
    YesterdayCustomersBaskets: "تعداد سفارشات دیروز مصرف کنندگان",
    TodayAgentsBaskets: "تعداد سفارشات امروز نمایندگان",
    YesterdayAgentsBaskets: "تعداد سفارشات دیروز نمایندگان",
    LatestSaledItems: "آخرین آیتم های فروش رفته",
    AgentName: "نام نماینده",
    InOrder: "در حال سفارش گیری",
    TemporarySubmission: "ثبت موقت",
    FinalSubmission: "ثبت نهایی",
    EditBasket: "ویرایش سفارش",
    SalesPersons: "متصدیان فروش",
    AgentAttach: "نسبت دادن نماینده",
    Agent: "نماینده",
    ReportComprehensiveTaxSystemForAgents:
      "گزارش سامانه جامع مالیاتی نمایندگان",
    ReportComprehensiveTaxSystemForCustomers:
      "گزارش سامانه جامع مالیاتی مشتریان",
    SearchAgent: "جست‌وجو نماینده",
    CreateTransferTransactionsViaExcel: " ثبت سندانتقال جدید از طریق اکسل",
    AddSpecificProductsListViaExcel: " افزودن لیست محصولات از طریق اکسل",
    ProductsList: "لیست محصولات",
    GetListExcelSerial: "دریافت اکسل لیست سریال‌ها",
    GetListExcelAllSerial: "دریافت اکسل لیست تمام سریال‌ها",
    AddGenericProductsListViaExcel: " افزودن دسته از طریق اکسل",
    AddReturnOrderViaExcel: " ثبت برگشت از فروش از طریق اکسل",
    ProductSegment: "سگمنت",
    CreateNewProductSegment: "درج سگمنت جدید",
    DeviceInfo: "اطلاعات دستگاه",
    BasketId: "شماره سفارش",
    DeviceType: "نوع دستگاه",
    OSInfo: "اطلاعات سیستم عامل",
    BrowserName: "نام مرورگر",
    DeviceName: "نام دستگاه",
    ProductSegments: "سگمنت‌ها",
    Agents: "نمایندگان",
    SearchProductSegment: "جست وجوی سگمنت",
    SalespersonProductsSegment: "سگمنت های متصدی فروش",
    AgentProductsSegment: "سگمنت های نماینده",
    SalesPersonAgents: "نمایندگان متصدی فروش",
    SearchUser: "جست و جو کاربر",
    EditProductSegment: "ویرایش سگمنت",
    Quotas: "سهمیه بندی",
    UploadExcel: "آپلود اکسل",
    Quota: "سهمیه",
    AgentQuotas: "سهمیه نماینده",
    QuotaDetails: "جزئیات سهمیه",
    ChargeQuota: "شارژ سهمیه",
    ReportQuota: "گزارش سهمیه",
    ReportWebSiteQuota: "گزارش سهمیه وبسایت",
    SaleAgentQuotaQueryWithInvertoryBalances: " گزارش موجودی سهمیه و انبار",
    DischargeQuota: "کسر سهمیه",
    Details: "جزئیات",
    User: "کاربر",
    AgentCredit: "اعتبار نماینده",
    YaldaEvent: "یلدا",
    PlaceOfPurchase: "محل خرید",
    TimeOfPurchase: "زمان خرید",
    AddRecipientInfo: "افزودن اطلاعات تحویل گیرنده",
    AddNewRecipient: "افزودن تحویل گیرنده جدید",
    CreateDischargePermission: "ثبت مجوز خروج",
    SearchDraftOrder: "جست وجو پیش فاکتور",
    Excel: "فایل اکسل",
    Ui: "عملیات کاربر",
    SaleAgentDraftOrderRejected: "رد پیش فاکتور نماینده",
    SaleAgentDraftOrderCreated: "ایجاد پیش فاکتور نماینده",
    DraftOrderRejected: "رد پیش فاکتور",
    DraftOrderCreated: "ایجاد پیش فاکتور",
    Reason: "علت",
    DemandCount: "تعداد درخواستی",
    RemainingCountForCheckout: "تعداد باقی مانده",
    CountOfCheckout: "تعداد خارج شده",
    CountOfRegistered: "تعداد ثبت شده",
    CountOfOperatorRequested: "تعداد درخواستی",
    DocumentRegistrationDate: "تاریخ ثبت سند",
    DraftOrderCount: "تعداد(پیش فاکتور)",
    CountOfDischargePermissionRegistered: "تعداد(مجوزهای خروج پیشین)",
    MyAgents: "نمایندگان من",
    FilesAndAttachments: "فایل ها و ضمائم",
    WaitingForDischargePermissionSubmission: "در انتظار ثبت مجوز خروج",
    DraftOrderWaitingForDischargePermissionSubmission:
      "پیش فاکتور در انتظار ثبت مجوز خروج",
    WaitingForCheckoutSubmission: "در انتظار ثبت حواله خروج",
    AllCheckouts: "همه",
    WithoutOrderCheckouts: "فاقد فاکتور",
    Processed: "پردازش شده",
    CreateOrder: "صدور فاکتور",
    EditAgentInfo: "ویرایش اطلاعات نماینده",
    MobileNumber: "شماره تلفن همراه",
    SubmitChanges: "ثبت تغییرات",
    EditRecipientInfo: "ویرایش اطلاعات تحویل گیرنده",
    ChooseCheckInFile: "انتخاب فایل برای صدور رسید ورود ",
    ChooseFileToUpdateTheTrackingId:
      " انتخاب فایل برای به روز رسانی شناسه رهگیری",
    ChooseCheckOutFile: "انتخاب فایل برای صدور حواله خروج",
    ChooseGetBasketFile: "انتخاب فایل برای ثبت سفارش",
    CheckInWithExcelFile: "رسید ورود از طریق اکسل",
    RecruitmentRequest: "درخواست همکاری",
    TypesOfCooperation: "شغل/زمينه هاي همكاري",
    QuotaCount: "تعداد سهمیه",
    AgentID: "شناسه نماینده",
    View: "مشاهده",
    RevertToConfirmed: "بازگشت به تایید شده ها",
    RevertToInOrder: "بازگشت به در حال سفارش‌گیری",
    SaleProductManagers: "مدیران محصول",
    BasicDefinitions: "تعاریف اولیه",
    SaleProductManagerContracts: "قراردادهای مدیرمحصول",
    SaleProductManagerFullName: "نام و نام خانوادگی مدیر محصول",
    SalePersonFullName: "نام و نام خانوادگی متصدی فروش",
    SaleProductManagerSegments: "سگمنت های مدیرمحصول",
    Segment: "سگمنت",
    SegmentName: "نام سگمنت",
    MySaleContracts: "قراردادهای فروش من",
    MySaleContractsManagemnet: "مدیریت قراردادهای من",
    GenericProductName: "عنوان دسته",
    OrderPayments: "پرداخت‌های سفارش",
    SumOfPaymentsAmount: "جمع مبالغ پرداختی",
    AddCashPayment: "ثبت پرداخت",
    Online: "آنلاین",
    Cash: "نقدی",
    Create: "ایجاد",
    Token: "توکن",
    CallBackFromBank: "کال بک از بانک",
    PaymentAttachmentImageContent: "تصویر پیوست پرداخت",
    EditCashPayment: "ویرایش پرداخت",
    StopProduction: "توقف تولید",
    ConfigurableProducts: "دستگاه‌های سفارشی",
    CreateNewConfigurableProduct: "درج دستگاه‌سفارشی جدید",
    EditConfigurableProduct: "ویرایش دستگاه‌سفارشی",
    PersianTitle: "عنوان فارسی",
    ConfigurableProductOptionsManagement: "مدیریت آپشن های دستگاه‌سفارشی",
    SearchGenericProduct: "جست‌وجو دسته‌بندی محصول",
    SpecificProduct: "آیتم",
    SpecificProductName: "نام محصول",
    SearchSpecificProduct: "جست‌و جوی آیتم‌",
    Subset: "زیرمجموعه",
    GenericItems: "آیتم‌های دسته",
    WebsiteVisitors: "بازدیدکنندگان وب‌سایت",
    OnlineUsers: "کاربران آنلاین",
    SalesPartners: "همیاران فروش",
    male: "مذکر",
    female: "مونث",
    Sex: "جنسیت",
    FatherName: "نام پدر",
    DateBirth: "تاریخ تولد",
    PlaceBirth: "محل تولد",
    PlaceIssue: "محل صدور",
    WriteAnswer: "نگارش پاسخ",
    PleaseEnterDescription: "لطفا توضیحات را وارد نمایید",
    MaximumCharacters: "(حداکثر160کاراکتر)",
    MaritalStatus: "وضعیت تاهل",
    Leased: "اجاره",
    HomePhone: "تلفن منزل",
    CallAnotherPhone: "شماره تلفن دیگر",
    FullAddressResidence: "نشانی کامل محل سکونت",
    MentionDatesRecords: "تاريخ ها و سوابق را ذكر كنید",
    BeenConvicted: "آيا تاكنون محكوميت كيفري داشته ايد ؟",
    employedcompanyinterviewedcompanyemployed:
      "آیاتاکنون دراستخدام این شرکت بوده اید ویادراین شرکت مصاحبه استخدامی داشته اید",
    Married: "متاهل",
    Rent: "استیجاری",
    OwnerHome: "شخصی",
    TypeOwnershipResidence: "نوع مالكیت محل سكونت‌",
    Single: "مجرد",
    NumberDependents: "تعداد افراد تحت تکفل",
    NumberChildren: "تعداد فرزندان",
    NameSurnameSpouse: "نام و نام خانوادگی همسر",
    Spousejob: "شغل همسر",
    SpousesWorkPhone: "تلفن محل کارهمسر",
    TypeExemption: "نوع معافیت",
    BasicInformation: "اطلاعات اولیه",
    ServiceStatus: "وضعیت خدمت",
    EndService: "پایان خدمت",
    BuyService: "خرید خدمت",
    DoExemptionCertificate: "آیا دارای مدرک معافیت هستید؟‌‌‌‌",
    Exemption: "معافیت",
    PermissionAccessSection: "شما مجوز دسترسی به این بخش را ندارید",
    NoPaymentInformation: "فاقد اطلاعات پرداخت",
    RecipientDeliveryNentered: "اطلاعات تحویل گیرنده وارد نشده است",
    CharacterType: "نوع شخصیت",
    CommodityPrices: "قیمت کالا",
    InsertSalesPartners: "درج همیار فروش",
    BusinessSidePersonality: "شخصیت طرف تجاری",
    ActiveSalesPartner: "پلن فعال همیارفروش",
    Account: "حساب",
    Accounts: "حساب ها",
    CreatorUser: "کاربر ایجادکننده",
    AmountCommission: "مبلغ کمیسیون",
    Commission: "کمیسیون",
    ReferenceDocument: "سند مرجع",
    MomentaryInventory: "موجودی لحظه‌ای",
    TypeConviction: "نوع محكوميت",
    Education: "تحصیلات",
    FullNameUniversity: "نام كامل دانشگاه",
    Degree: "مدرک تحصیلی",
    FieldStudy: "رشته تحصیلی",
    Adjusted: "معدل",
    Diploma: "دیپلم",
    Skill: "کاردانی",
    Bachelor: "کارشناسی",
    Expert: "کارشناسی ارشد",
    Phd: "دکتری",
    WorkHistory: "سوابق كاری",
    CurrentWorkplace: "محل كار كنونی/آخرين محل كار",
    PreviousWorkplace: "محل كار قبلی",
    FieldActivityCompany: "زمینه فعالیت شرکت",
    PositionOccupation: "سمت/شغل‌",
    NumberEmployees: "تعداد کارکنان",
    EndDateCooperation: "تاریخ پایان همکاری",
    StartDateCooperation: "تاریخ شروع همکاری",
    NameSupervisoManager: "نام سرپرست/مدیر مستقیم‌",
    ReasonTerminationCooperation: "علت خاتمه/تمايل به خاتمه همكاری",
    BasicSalaryBenefits: "حقوق و مزايای اولیه",
    LatestSalaryBenefits: "آخرین حقوق و مزایا",
    Responsibilities: "مسئولیت های شما",
    PhoneCall: "تلفن تماس",
    AllowedCall: " آیا مجاز به تماس هستیم؟",
    HealthItems: "موارد مربوط به بهداشت و درمان",
    BloodType: "گروه خونی",
    SpecificDisease: "آيا بيماري خاصي داريد",
    SmokingCertainDrugs: "آيا عادت به مصرف دخانيات، داروي خاص، ... داريد",
    ActivitiesSkills: "فعالیت‌هاو مهارت‌ها",
    EducationalSpecialized: "دوره‌های آموزشی/تخصصی",
    CourseName: "نام دوره",
    Year: "سال",
    Duration: "مدت",
    WarrantyDuration: "مدت گارانتی",
    AlternativeWarrantyItemType: "نام آیتم گارانتی",
    FullInstitute: "نام کامل مؤسسه",
    EventPlace: "محل برگزاری",
    CertificateCompletion: "گواهي پايان دوره",
    ForeignLanguageOne: "زبان خارجی1",
    Skills: "مهارت ها",
    ForeignLanguageTwo: "زبان خارجی2",
    Level: "سطح",
    ComputerSkills: "مهارت‌های کامپیوتری‌",
    ComputerFamiliar: "سایر مهارت‌های کامپیوتری كه با آن‌ها آشنايي داريد‌",
    HardwareFamiliar: "سخت افزارهايي كه با آن‌ها آشنايي داريد",
    OtherSkills: "سایر مهارت‌ها(فنی،حرفه‌ایی)",
    SpecialAchievements: "موفقیت‌های خاص",
    DriverLicense: "آيا گواهینامه رانندگی داريد؟",
    YearAcquisition: "سال اخذ",
    TraveledAbroad: "آيا تاكنون سفر خارج از كشور رفته ايد؟",
    Country: " کشور",
    NameCountry: "نام کشور",
    ProducingCountry: "کشور تولیدکننده",
    YearTravel: "سال سفر",
    ReasonTravel: "علت سفر",
    LeisureActivities: "فعاليتها و سرگرمي هاي اوقات فراغت",
    Study: "مطالعه",
    Sport: "ورزش",
    MembershipVarious: "عضويت در مراكز مختلف",
    ActivitiesCharity: "فعالیت در امور خیريه",
    RestInformation: "سایر اطلاعات",
    ReferCommunicate: "نحوه مراجعه/ارتباط",
    AcquaintedAvazang: "از چه طریق با آواژنگ آشنا شده اید؟",
    Poster: "اگهی",
    Historian: "مورخ",
    IntroducingPeople: "معرفی افراد",
    Other: "سایر",
    FamiliarEmployees: "آيا با كاركنان این شرکت آشنايي و يا نسبتي داريد؟",
    ExplainColleague: "لطفا با ذكر نام همكار، توضيح دهيد",
    PeopleExcept:
      "لطفا 3 نفر (به غیر از بستگان درجه یک) که می توانند شناخت خود را از خصوصیات یا توانایی حرفه ای شما در اختیار ما بگذاراند را ذکر نمائید",
    Proportion: "نسبت",
    PlaceActivity: "محل فعاليت",
    PositionActivity: "سمت/نوع فعاليت",
    ContactPhones: "تلفن هاي تماس",
    FirstRelative: "اطلاعات بستگان درجه یک",
    MembersEmergencies:
      "لطفا نام دو نفر از اعضای خانواده را جهت موارد اضطراری ذکر نمایید",
    DesiredJob: "شغل مورد نظر",
    Jobinterest: "شغل/زمينه هاي همكاري موردنظر خود را نام ببريد",
    PreparationWork: "زمان آمادگي براي شروع كار",
    AmountRequested: "ميزان حقوق درخواستی",
    OpportunityOvertime: " آيا امكان حضور در زمان خارج از وقت اداري را داريد؟",
    ResumeAttachment: "پیوست رزومه",
    Not: "ندارد",
    storage: "ذخیره",
    RegisterDiscountCode: "ثبت کد تخفیف",
    AddItem: "افزودن کالا",
    IsActive: "فعال بودن",
    limitationOnPurchase: "محدودیت در خرید",
    plate: "پلاک",
    typeOfTransport: "نوع وسیله حمل و نقل",
    model: "مدل",
    RejectPackage: "رد مرسوله",
    Package: "مرسوله",
    Packages: "مرسولات",
    PackageName: "نام مرسوله",
    PackageCount: "تعداد مرسوله",
    PackageInfo: "مشخصات مرسوله",
    OperatorInfo: "مشخصات اپراتور",
    userSender: "کاربر ارسال کننده",
    CreateNewPackage: "ایجاد مرسوله جدید",
    OperatorChoice: "انتخاب اپراتور",
    ToolTransportChoice: "انتخاب وسیله حمل و نقل",
    driverLicenseNumber: "شماره گواهینامه",
    ShippingManagement: "مدیریت حمل و نقل",
    ActionTime: "زمان فعالسازی",
    ActionUser: "کاربر فعال کننده",
    CreateNewTransportTool: "ایجاد وسیله حمل و نقل جدید",
    CreateNewTransportFleet: "ایجاد ناوگان حمل و نقل جدید",
    TransportTools: "وسیله‌های حمل و نقل",
    CreateNewOperator: "ایجاد اپراتور جدید",
    Operators: "اپراتورها",
    OperatorFullName: "نام کامل اپراتور",
    TransportFullName: "نام کامل وسیله حمل و نقل",
    TransportName: "نام وسیله حمل و نقل",
    Transport: "وسیله حمل و نقل",
    billOfLadingNumber: "شماره بارنامه",
    TransportFleets: "ناوگان‌های حمل و نقل",
    TransportFleet: "ناوگان‌ حمل و نقل",
    // TransportFleetInfoChoice: "انتخاب ناوگان حمل و نقل",
    OperationOperators: "عملیات اپراتورها",
    ReportOperationOperators: "گزارش عملیات اپراتورها",
    ConfirmDeliveryToCustomer: "تایید تحویل به مشتری",
    WaitingForConfirm: "در انتظار تایید",
    WaitingForDeliveryToCustomer: "در انتظار تحویل به مشتری",
    WaitingForDeliveryToOperator: "در انتظار تحویل به اپراتور",
    WaitingForAssignOperator: "در انتظار ثبت اپراتور",
    WaitingForReceiveToOrigin: "در انتظار دریافت از مبدا",
    PackageId: "شناسه مرسوله",
    ConfirmReceivePackage: "تایید دریافت مرسوله",
    Cost: "هزینه",
    deliveredTimeToCustomer: "زمان تحویل به مشتری",
    deliveredTimeToOperator: "زمان تحویل به اپراتور",
    CostAndFreight: "هزینه و باربری",
    Freight: "باربری",
    SubmitCostAndFreight: "ثبت هزینه و باربری",
    SubmitCountOfCarton: "ثبت تعداد کارتن",
    SubmitOperator: "ثبت اپراتور",
    EditOperator: "ویرایش اپراتور",
    EditCostAndFreight: "ویرایش هزینه و باربری",
    EditCountOfCarton: "ویرایش تعداد کارتن",
    Attachments: "ضمائم",
    Attachment: "ضمیمه",
    ReceiptDelivered: "رسید تحویل",
    ConfirmDelivered: "تایید تحویل",
    ViewReceipt: "مشاهده رسید",
    ViewReceiptPackage: "مشاهده رسید مرسوله",
    Cartable: "کارتابل",
    StartTime: "زمان شروع",
    Motorcycle: "موتور سیکلت",
    PickUp: "وانت",
    Truck: "کامیون",
    PhoneNumberCustomer: "شماره تماس مشتری",
    preparing: "در حال آماده‌سازی",
    TotalCountItems: "تعداد کل ایتم‌ها",
    OperatorPhoneNumber: "شماره تماس اپراتور",
    MoreDetails: "جزئیات بیشتر",
    ApplicantId: "شناسه درخواست کننده",
    nickName: "نام مستعار",
    SalesPartnersPlans: "پلن های همیاران فروش",
    AssignUsers: "افزودن اعضا",
    AssignSegmentToProduct: "اختصاص سگمنت به محصولات",
    AssignProductToSegment: "اختصاص محصولات به سگمنت",
    FindSegmentForProduct: "پیدا کردن سگمنت محصولات",
    ChooseSegment: "انتخاب سگمنت",
    UsersList: " لیست کاربران ",
    NotificationManagement: "مدیریت پیام‌ها",
    NotificationTemplate: "قالب پیام‌ها",
    EnglishTitle: "عنوان انگلیسی",
    NotificationTitle: "عنوان پیام",
    NotificationTitleAndText: "عنوان و متن پیام",
    NotificationText: "متن پیام",
    AddReceiver: "افزودن گیرنده",
    ReceiverCC: "دریافت‌کننده رونوشت (CC)",
    ReceiverCCList: "لیست دریافت‌کننده رونوشت (CC)",
    Receiver: "گیرنده",
    Receivers: "گیرنده‌ها",
    ReceiversList: "لیست گیرنده‌ها",
    SearchReceiver: "جستجو گیرنده",
    AbilitySearchCompanyName_firstName_lastName_code:
      "امکان جستجوی نام شرکت، نام و نام خانوادگی، کد نماینده",
    AbilitySearchBrandName_EnglishProductName_FarsiProductName_ItemCode:
      "امکان جستجوی نام برند، نام انگلیسی کالا، نام فارسی کالا و کد کالا",
    AbilitySearchAgentName: "امکان جستجوی نام نماینده",
    CreateNewReceiver: "درج گیرنده جدید",
    ModifyReceiver: "درج گیرنده جدید",
    CreateLegalAgentWithExcel: "ایجاد نماینده حقوقی با اکسل",
    CreateIndividualAgentWithExcel: "ایجاد نماینده حقیقی با اکسل",
    Notifications: "پیام‌ها",
    SendStatus: "وضعیت ارسال",
    Untitled: "بدون عنوان",
    RejectDischargePermission: "رد مجوز خروج",
    SalePersonName: "نام واسطه فروش",
    ReasonOfOrderReject: "دلیل رد سفارش",
    DateSettlement: "تاریخ تسویه",
    EditDateSettlement: "ویرایش تاریخ تسویه",
    SubmitDateSettlement: "ثبت تاریخ تسویه",
    Calendar: "تقویم",
    CriticsAndSuggestions: "انتقادات و پیشنهادات",
    TextCriticOrSuggestion: "متن انتقاد یا پیشنهاد",
    AllCriticsAndSuggestions: "همه انتقادات و پیشنهادات",
    NotAnswered: "پاسخ داده نشده",
    Answered: "پاسخ داده شده",
    CloseOrderBasket: "بستن سبد سفارش",
    TotalAmountOrder: "مبلغ کل فاکتور",
    IdentificationCode: "شناسه کالا",
    guranteeIdentification: " شناسه گارانتی",
    WithoutIdentificationCode: "بدون شناسه کالا",
    WaitingForCreateOrder: "در انتظار صدور فاکتور",
    WaitingForPrintWarrantyCard: "در انتظار چاپ کارت گارانتی",
    FinishOperationPrintWarrantyCard: "پایان عملیات چاپ کارت گارانتی",
    PrintWarrantyCard: "چاپ کارت گارانتی",
    PrintLabel: "چاپ برچسب",
    AddSerialWithBarcodeReader: " سریال با بارکدخوان",
    AddSerialWithBarcodeReaderAccumulative: " سریال با بارکدخوان تجمیعی",
    AddSerialWithBarcodeReaderSingle: "افزودن سریال با بارکدخوان تکی",
    PrintTableUnder: "چاپ جدول زیر",
    ForceProccess: "تایید اجباری",
    Close: "بستن",
    UpdateDataFromKhadamat: "به‌روز‌رسانی اطلاعات از خدمات",
    ListOfWarehouseHandlingsThisTerm: "لیست انبارگردانی‌های این دوره",
    DiscrepancyCheck: "مغایرت‌یابی",
    ShowDiscrepancy: "نمایش مغایرت",
    ClearCounting: "پاک کردن شمارش",
    DetailCountingGroups: "جزییات شمارش‌ گروه‌ها",
    Groups: "گروه‌ها",
    DetailCounting: "جزییات شمارش‌",
    DetailsWarehouseHandling: "جزییات انبارگردانی",
    EditCounting: "ویرایش شمارش",
    Counting: "شمارش",
    RepeatCounting: "تکرار شمارش",
    StartCounting: "شروع شمارش",
    EndCounting: "پایان شمارش",
    CreateNewCounting: "ایجاد شمارش جدید",
    WarehouseFinancialReport: "گزارش مالی انبار",
    // GroupingAndStartingWarehouseHanding: "گروه بندی و شروع انبارگردانی"
    CreateGrouping: "ایجاد گروه بندی",
    PhoneNumberLeader: "شماره تماس مسئول",
    Zone: "زون",
    ShowSubmitBarcode: "نمایش بارکدهای ثبت شده",
    DeductionDisrepancy: "کسری مغایرت",
    IncreaseDisrepancy: "اضافات مغایرت",
    DownloadExcelReportWarehouseHanding: "دانلود گزارش اکسل انبارگردانی",
    DownloadExcelItemCodesOfTheSerialsTaken:
      "دانلود اکسل ایتم کدهای سریال‌های گرفته شده",
    NotIranianCitizen: "تبعه غیر‌ ایرانی",
    CivilPartnership: "مشارکت مدنی",
    AgentCode: "کد نماینده",
    InventoryRecharge: "آزادسازی رزرو",
    InventoryReserve: "رزرو",
    InventoryReservation: "رزرواسیون",
    CreditPayment: "اعتباری",
    MarketPrice: "مارکت پرایس",
    CreateMarketPrice: "درج مارکت پرایس",
    DownloadContractProducts: "دانلود محصولات قرارداد",
    UploadMarketPrice: "بارگذاری مارکت پرایس",
    AvailableMarketPrices: "مارکت پرایس‌های موجود",
    MarketPriceHistory: "تاریخچه مارکت پرایس",
    BaseSalePrice: "قیمت پایه فروش",
    CreateBaseSalePrice: "درج قیمت پایه فروش",
    BaseSalePriceHistory: "تاریخچه‌ی قیمت پایه فروش",
    AvailableBaseSalePrices: "قیمت‌های پایه فروش",
    UploadBaseSalePrice: "بارگذاری قیمت پایه فروش",
    ProductSearch: "جستحوی کالا",
    AgentSearch: "جستجوی نماینده",
    QuataTransactionsDetails: "جزئیات تراکنش‌ها",
    AbilitySearchBrandName_ItemCode: "امکان جستجوی کد کالا",
    AbilitySearchAgentCode: "امکان جستجوی کد نماینده",
    ExpirationDate: "تاریخ انقضا",
    DischargeAllExpiredQuotas: "کسر سهمیه‌های منقضی شده",
    ExpiredDate: "سپری شدن تاریخ انقضا",
    Table: "جدول",
    Chart: "نمودار",
    Upload: "بارگذاری",
    UploadDocuments: "بارگذاری مدارک",
    DocumentType: "نوع مدرک",
    PaymentId: "شناسه پرداخت",
    CashPaymentId: " شناسه پرداخت نقدی",
    OnlinePaymentId: " شناسه پرداخت آنلاین",
    Contents: "محتوا",
    EditContent: "ویرایش محتوا",
    CreateNewContent: "درج محتوا جدید",
    ItemTitle: "عنوان آیتم",
    BackgroundColor: "رنگ پشت‌زمینه",
    ContentItems: "آیتم‌ها",
    Subtitle: "زیرنویس",
    UploadAttachments: "بارگذاری پیوست‌ها",
    AttachmentType: "نوع پیوست",
    File: "فایل",
    UploadAttachment: "بارگذاری پیوست",
    GuaranteeIdentification: "شناسه گارانتی",
    PettyCash: " تنخواه",
    WaitingForDischargePermissionConfirmation: "در انتظار تایید مجوز خروج",
    WaitingForOperatorToApprove: "در انتظار تایید اپراتور",
    Considerations: "ملاحضات",
    SaleTargets: "تارگت‌های فروش",
    CreateSaleTarget: "ایجاد تارگت فروش",
    SaleTargetsSegments: "سگمنت‌های تارگت فروش",
    SegmentId: "شناسه سگمنت",
    SalesPersonsPerformance: "گزارش فروش متصدیان فروش بر اساس تارگت",
    HoldersOfTheRightToSignName: "صاحبان حق امضا",
    ProvinceAndCityName: "آدرس",
    AmountOfOrdersPerSaleTarget: "درصد فروش از تارگت",
    WarrantyItemType: "نام آیتم گارانتی",
    Targets: "تارگت‌ها",
    CreateLegalCustomerWithExcel: "ایجاد مشتری حقوقی با اکسل",
    CreateIndividualCustomerWithExcel: "ایجاد مشتری حقیقی با اکسل",
    ProcurementManagement:" تامین و تدارکات",
    PurchaseRequest:" درخواست خرید",
    CreatePurchaseRequest:" ثبت درخواست خرید",
    EditPurchaseRequest:"ویرایش درخواست خرید",
    AllPurchaseRequest:"همه درخواست خرید ها",
    AllPreInvoice:"همه پیش فاکتور ها",
    PreInvoice:"پیش فاکتور",
    EditPreInvoice:"ویرایش پیش فاکتور",
    Invoice:"فاکتور",
    DeliveryDate:"تاریخ تحویل",
    Unit:"واحد اندازه گیری",
    CreateDepartmans:"ایجاد دپارتمان",
    EditDepartmans:"ویرایش دپارتمان",
    CreateUnit:"ایجاد واحد اندازه گیری",
    EditUnit:"ویرایش واحد اندازه گیری",
    Departman:"دپارتمان",
    Suppliers: "تولید کنندگان",
    Supplier: "تولید کننده",
    EditSupplierInfo: "ویرایش اطلاعات تولید کنندگان",
    SupplierID: "شناسه تولید کننده",
    SupplierCode: "کد تولید کننده",
    SupplierSearch: "جستجوی تولید کننده",
    CreateNewSupplier: "درج تولید کننده جدید",
    CreateIndividualSupplier: "درج تولید کننده حقیقی",
    CreateLegalSupplier: "درج تولید کننده حقوقی",
    SupplierType: "نوع تولید کننده",
    SupplierOwnerNumber:"شماره موبایل مالک",
    EditSupplier: "ویرایش تولید کنندگان",
    EditLegalSupplier: "ویرایش تولید کننده حقوقی",
    EditIndividualSupplier: "ویرایش تولید کننده حقیقی",
    SupplierName: "نام تولید کننده",
    SearchSupplier: "جست‌وجو تولید کننده",
    MySuppliers: "تولید کنندگان من",
    EditSupplierInfo: "ویرایش اطلاعات تولید کننده",
    CreateLegalSupplierWithExcel: "ایجاد تولید کننده حقوقی با اکسل",
    CreateIndividualSupplierWithExcel: "ایجاد تولید کننده حقیقی با اکسل",
    AbilitySearchSupplierName: "امکان جستجوی نام تولید کننده",
    AbilitySearchSupplierCode: "امکان جستجوی کد تولید کننده",
    Geography:"جغرافیا",
    Countries:"کشورها",
    Cities:"شهرها",
    Provinces:"استان ها",
    CreateCountry:"ایجاد کشور",
    CreateCity:"ایجاد شهر",
    CreateProvince:"ایجاد استان",
    CreateNewCountry:" درج کشور جدید",
    ModifyCountry:" ویرایش کشور جدید",
    CreateNewProvince:" درج استان جدید",
    ModifyProvince:" ویرایش استان جدید",
    CreateNewCity:" درج شهر جدید",
    ModifyCity:" ویرایش شهر جدید",
    CityName:" نام شهر ",
    ProvinceName:"نام استان",
    Departman:"دپارتمان",
    PreInvoiceDetails:"جزییات پیش سفارش",
    CurrencyType:"نوع ارز",
    EditCurrencyType:"ویرایش نوع ارز",
    EditUnitPrice:"ویرایش قیمت واحد",
    EditItemCode:"ویرایش کد کالا",
    SaveCurrencyType:"ثبت نوع ارز",
    SaveUnitPrice:"ثبت قیمت واحد",
    UnitPrices:" قیمت واحد",
    SaveItemCode:"ثبت کد کالا",
    PurchaseOrder:"پیش سفارش",
    EditPurchaseOrder:"ویرایش پیش سفارش",
    SaveSupplier:"ثبت تولید کننده",
    AllPurchaseOrder:"همه پیش سفارش ها",
    DeductionAndIncrease:"کسر و اضافه",
    CreateNewDeductionAndIncrease:"ایجاد کسر و اضافه",
    EditNewDeductionAndIncrease:"ویرایش کسر و اضافه",
    DeductionAndIncreaseType:"نوع کسر و اضافه",
    toleranceTypes:"نوع تلرانس",
    SaveEditDeductionAndIncrease:"ذخیره تغییرات کسر و اضافه",
    AmountSourceCurrency:"قیمت واحد ارز مبدا",
    TotalAmountSourceCurrency:"جمع قیمت واحد ارز مبدا",
    AmountSourceCurrencyWithDeduction:"قیمت واحد پس از کسر و اضافه",
    TotalAmountSourceCurrencyWithDeduction:"جمع قیمت ارز واحد مبدا پس از کسر و اضافه",
    AmountTargetCurrency:"قیمت واحد ارز مقصد",
    TotalAmountTargetCurrency:"جمع قیمت واحد ارز مقصد",
    AmountTargetCurrencyWithDeduction:"قیمت واحد ارز مقصد پس از کسر و اضافه",
    TotalAmountTargetCurrencyWithDeduction:"جمع قیمت واحد ارز مقصد پس از کسر و اضافه",
    TotalAmountOfSourceCurrency:"مبلغ کل پیش فاکتور با ارز مبدا",
    TotalAmountOfSourceCurrencyAfterDeductionAndIncrease:"مبلغ کل پیش فاکتور با ارز مبدا پس از کسر و اضافه",
    TotalAmountOfTargetCurrency:"مبلغ کل پیش فاکتور با ارز مقصد",
    TotalAmountOfTargetCurrencyAfterDeductionAndIncrease:"مبلغ کل پیش فاکتور با ارز مقصد پس از کسر و اضافه",
    EditPurchaseInvoice:"ویرایش پیش فاکتور",
    PurchaseInvoice:"پیش سفارش",
    PurchaseInvoiceShippment:"پیش فاکتور خرید",
    Rate:"نرخ",
    SourceCurrency:"ارز مبدا",
    TargetCurrency:"ارز مقصد",
    PettyCashAccountCreate:"درج حساب جدید برای تنخواه",
    Receipts:"دریافت ها ",
    Payments:"پرداخت ها ",
    CreateReceipts:"ایجاد دریافت ",
    CreatePayments:"ایجاد پرداخت ",
    OriginParties:"طرف تجاری مبدا ",
    DestinationParties:"طرف تجاری مقصد ",
    OriginAccount:"حساب مبدا ",
    DestinationAccount:"حساب مقصد ",
    AccountCreate:"افزودن حساب ",
    AccountCode:"کد حساب ",
    CreateNewSubcategoryFloatingAccount:" ایجاد حساب زیرمجموعه",
    Connections:" ارتباطات",
    CostCenter:" مرکز هزینه",
    CreateCostCenter:" ایجاد مرکز هزینه",
    CostCenterTitle:" عنوان مرکز هزینه",
    PettycashManagement:"مدیریت تنخواه",
    Pettycashs:"تنخواه داران",
    Pettycash:"تنخواه دار",
    PettycashPayment:"پرداخت هزینه تنخواه",
    CreatePettycashPayment:"ایجاد پرداخت هزینه تنخواه",
    ChargePettycashsAccount:"شارژ حساب تنخواه داران",
    CreateChargePettycashsAccount:"ایجاد شارژ حساب تنخواه داران",
    Payer:"پرداخت کننده",
    Receiver:"دریافت کننده",
    PayerAccount:"حساب پرداخت کننده",
    ReceiverAccount:"حساب دریافت کننده",
    PayerFloatingAccount:"حساب شناوری پرداخت کننده",
    ReceiverFloatingAccount:"حساب شناوری دریافت کننده",
    PayerCostCenter:"مرکز هزینه پرداخت کننده",
    ReceiverCostCenter:"مرکز هزینه دریافت کننده",
    AccountFloating:" حساب شناوری",
    AccountFloatingCode:"  کد حساب شناوری",
    Creditor:"بستانکار",
    Debtor:"بدهکار",
    ChargeAccount:"شارژ حساب",
    CostTitles:"عنوان های هزینه",
    CostTitle:"عنوان هزینه",
    CreateCostTitle:"ایجاد عنوان هزینه",
    ExpenseAccount:"حساب هزینه ای",
    FloatingExpenseAccount:"حساب تفضیلی هزینه ای",
    PrePaymentAccount:"حساب پیش پرداخت",
    Expenses:"هزینه ها",
    BankReferenceId:"شماره رهگیری بانک",
    IncludeTax:"مشمول مالیات",
    PreInvoiceWaitingForInvoice:"پیش فاکتور های در انتظار فاکتور",
    PreInvoiceWaitingForProcess:"پیش فاکتور  های در حال پردازش",
    InvoiceWaitingForConfirm: " فاکتور های در انتظار تایید",
    PreOrderWaitingForPreInvoice:"پیش سفارش های در انتظار پیش فاکتور",
    PreOrderWaitingForProcess:"پیش سفارش  های در حال پردازش",
    PreInvoiceWaitingForConfirm: " پیش فاکتور های در انتظار تایید",
    CountOfPurchaseOrderRegistered:"تعداد(پیش فاکتور های صادر شده)",
    CountOfPurchaseOrder:"تعداد کل (پیش سفارش)",
    CurrencyRate:"نرخ ارز",
    EffectiveAmount:"مبلغ ماثر کسر و اضافه",
    CurrencyExchange:"تبدیلات ارزی",
    CreateCurrencyExchange:" ایجاد تبدیل ارزی",
    InvoiceDetails:" جزییات فاکتور",
    PurchaseInvoiceDetails:" جزییات پیش فاکتور",
    PurchaseOrderDetails:" جزییات پیش سفارش",
    PurchaseRequestDetails:" جزییات درخواست خرید",
    BrokerInvoice:"فاکتور کارگزاری",
    BrokerInvoiceDetails:"جزییات فاکتور کارگزاری",
    InvoiceWaitingForBrokerInvoice:"فاکتورهای در انتظار فاکتور کارگزاری",
    InvoiceWaitingForProcess:"فاکتورهای در حال پردازش",
    Cargo:"محموله",
    PreInvoiceWaitingForCargo: " پیش فاکتور های در انتظار صدور محموله",
    PreInvoiceProcessed:" پیش فاکتور های پردازش شده",
    Send:"ارسال",
    Recieve:"دریافت",
    RecieveDetails:"جزییات دریافت محموله",
    CargoProcessed:"مرسوله های پردازش شده",
    CargoDelivered:"مرسوله های تحویل داده شده",
    PreInvoiceDelivered:"پیش فاکتور های تحویل داده شده",
    ShipmentWaitingForCargo: " محموله های در انتظار مرسوله",
    ShipmentWaitingForProcess:"محموله های در حال پردازش",
    CountOfPackageRegistered:"تعداد(پکیج های صادر شده)",
    CountOfShipment:"تعداد کل (شیپمنت)",
    SavePassagePermit:"ثبت پته عبور",
    SavePackage:"ثبت پکیج",
    SerialsUpload:"آپلود سریال",
    CountOfPurchaseInvoiceRegistered:"تعداد(شیپمنت های صادر شده)",
    CountOfPurchaseInvoice:"تعداد کل (پیش فاکتور)",
    IncludeTax:"مشمول مالیات",
    VoucherCode:"شماره سند",
    Report: "گزارش‌",
    sumOfDebtor:"مجموع بدهکار",
    sumOfCreditor:"مجموع بستانکار",
    sumOfBalance:"مجموع مانده",
    CreateAgent:"ایجاد نماینده",
    CreateSupplier:"ایجاد تولید کننده",
    AgentRequest:"درخواست نمایندگی",
    ReceivePackage:"درخواست نمایندگی",
    WaitingForReceive:"در انتظار دریافت" ,
    InvoiceCount: "تعداد( فاکتور)",
    PurchaseInvoiceCreate: "صدور پیش فاکتور",
    ShipmentCreate: "صدور شیپمنت",
    PackageUpload: "آپلود پکینگ لیست",
    ShowPackingList: "مشاهده پکینگ لیست",
    PackingList: " پکینگ لیست",
    GrossWeight: " وزن ناخالص",
    NetWeight: " وزن خالص",
    TotalGrossWeight: " مجموع وزن ناخالص",
    TotalNetWeight: " مجموع وزن خالص",
    CountyOfRegion: "کشور سازنده",
    CountInEachCartoon: " تعداد در هر کارتون",
    CountOfCartoons: " تعداد کارتون ها",
    PalletNumber: " شماره پلت",
    PalletWeight: " وزن پلت",
    ShipmentInfo: " اطلاعات محموله",
    RefrenceInfo: " اطلاعات سند مرجع فروشنده",
    EditWeight: " ویرایش وزن کالا",
    EditWarrantyItemId: " ویرایش شناسه کالا و گارانتی",
    RecieveShipment: "محموله های دریافتی",
    PurchaseInvoiceId: "شناسه پیش فاکتور",
    SupplyClock: "تاریخ تامین",
    SaveSupplyClock: "ثبت تاریخ تامین",
    SendingPartial: "در حال ارسال ( پارشیال )",
    WarehouseId:"شناسه انبار" ,
    ShelveId:"شناسه قفسه" ,
    CostOfGoodsPurchased:"بهای تمام شده" ,
    SumCostOfGoodsPurchased:" مجموع بهای تمام شده" ,
    PurchaseOrderUpload: "آپلود لیست خرید",
    TadbirId:"شناسه تدبیر",
    UploadItemCode:"آپلود کد کالا",
    UploadUnitPrice:"آپلود قیمت واحد",
    UploadWieght:"آپلود وزن کالا",
  },
};
